import Vue from 'vue'
import Vuex from 'vuex'

// modules
import users from './modules/users';
import profiles from './modules/profiles';
import layout from './modules/layout';
import settings from './modules/settings';
import login from './modules/login';
import cpconfiguration from './modules/cpconfiguration';
import monitoring from './modules/monitoring';
import billing from './modules/billing';
import reporting from './modules/reporting';
import accountsetting from './modules/accountsetting';
import admins from './modules/admins';
import tasks from './modules/tasks';
import cpdatas from './modules/cpdatas';
import externalintegration from './modules/externalintegration';
import dashboard from './modules/dashboard';
import captiveportal from './modules/captiveportal';
import paymentCollection from './modules/paymentCollection';
import accesspoints from './modules/accesspoints';
import announcements from './modules/announcements';
import leads from './modules/leads';
import inventory from './modules/inventory';
import franchiseManagement from './modules/franchiseManagement';
import helpdesk from './modules/helpdesk';
import iptv from './modules/iptv';
import voicephone from './modules/voicephone';
import license from './modules/license';
import lockscreen from './modules/lockscreen';
import analytics from './modules/analytics';
import networksettings from './modules/networksettings';
import networkdiagnostics from './modules/networkdiagnostics';
import systemtools from './modules/systemtools';
import discount from './modules/discount';
import overview from './modules/overview';
import payment from './modules/payment';
import register from './modules/register';
import application from './modules/application';

Vue.use(Vuex); systemtools

export const store = new Vuex.Store({
    modules: {
        users,
        profiles,
        layout,
        settings,
        login,
        cpconfiguration,
        monitoring,
        billing,
        reporting,
        accountsetting,
        admins,
        tasks,
        cpdatas,
        externalintegration,
        dashboard,
        captiveportal,
        paymentCollection,
        accesspoints,
        announcements,
        leads,
        inventory,
        franchiseManagement,
        helpdesk,
        iptv,
        voicephone,
        license,
        lockscreen,
        analytics,
        networksettings,
        networkdiagnostics,
        systemtools,
        discount,
        overview,
        payment,
        register,
        application
    }
})
